import Vue from "vue";
import App from "./App.vue";
import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.min.css";
import "vue-material/dist/theme/default.css";
import VueSweetalert2 from "vue-sweetalert2";
import Animate from 'animate.css'
import router from "./router";
import Vuelidate from "vuelidate";
// Install BootstrapVue
import {BootstrapVue, IconsPlugin, BIcon} from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import CryptoJS from 'crypto-js';

Vue.component("BIcon", BIcon);

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

Vue.component("DatePicker", DatePicker);

//Import vue Router
import VueRouter from "vue-router";
import VueSignaturePad from "vue-signature-pad";

import {Slide} from "vue-burger-menu"; // import the CSS transitions you wish to use, in this case we are using `Slide`

import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr"; // https://github.com/se-panfilov/mini-toastr
import Axios from "axios";
import VueSession from "vue-session";

import VueContext from "vue-context";

Vue.component("vue-context", VueContext);

import VueNumberInput from "@chenfengyuan/vue-number-input";

Vue.use(VueNumberInput);

import "vue2-timepicker/dist/VueTimepicker.css";
import VueTimepicker from "vue2-timepicker";

Vue.component("vue-timepicker", VueTimepicker);


import JsonExcel from "vue-json-excel";

Vue.component("downloadExcel", JsonExcel);

import {ValidationProvider, ValidationObserver, extend} from "vee-validate";
import {required} from "vee-validate/dist/rules";

extend("required", {
    ...required,
    message: "Este campo es requerido",
});
Vue.component("validation-provider", ValidationProvider);
Vue.component("validation-observer", ValidationObserver);
Vue.component("ValidationObserver", ValidationObserver);

import Tooltip from "vue-directive-tooltip";
import "vue-directive-tooltip/dist/vueDirectiveTooltip.css";

Vue.use(Tooltip);

import Vue2Filters from "vue2-filters";

Vue.use(Vuelidate);
Vue.use(Vue2Filters);

/*PTI presuntivo */
import VueMoment from "vue-moment";
import moment from "moment";

moment.locale('es');
Vue.use(VueMoment, {
    moment,
});

//para imprimir
import VueHtmlToPaper from "vue-html-to-paper";

const optionsPaper = {
    name: "_blank",
    specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
    styles: [
        "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
        "http://localhost:8080/beta.css",
    ],
};


import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

Vue.component("loading", Loading);
Vue.use(VueSession);
/*PTI presuntivo */

import vSelect from "vue-select";

Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";

/** archivirri de bootstrap personalizado*/
import "./assets/css/beta.css";
import "./assets/css/dentalia.css";
import "./assets/css/overwrite.css";
import 'vue-swatches/dist/vue-swatches.css';

miniToastr.init();

function toast({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb);
}

import {library} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

import {
    faFileSignature,
    faCoins,
    faPiggyBank,
    faChartLine,
    faArrowRight,
    faQuestionCircle,
    faSync,
    faUser,
    faCashRegister,
    faGavel,
    faFileAlt,
    faListOl,
    faClipboardList,
    faCalendarAlt,
    faNotesMedical,
    faTooth,
    faFlask,
    faLaughBeam,
    faToolbox,
    faTasks,
    faReply,
    faFolderOpen,
    faFileMedicalAlt,
    faChild,
    faRandom,
    faSignOutAlt,
    faExclamationTriangle,
    faLaptopMedical,
    faStarHalfAlt,
    faClinicMedical,
    faPrint,
    faDiagnoses,
    faDrum,
    faDrumSteelpan,
    faCalendarCheck,
    faMoneyBill,
    faIdCard,
    faPaw,
    faLockOpen,
    faPencilAlt,
    faEye,
    faLock,
    faTeeth,
    faEdit,
    faCopy,
    faFileInvoice,
    faCheckCircle,
    faTimesCircle,
    faMoneyCheckAlt,
    faPrescriptionBottleAlt,
    faStickyNote,
    faArrowCircleRight,
    faAssistiveListeningSystems,
    faHistory,
    faUndoAlt,
    faExchangeAlt,
    faCircle
} from '@fortawesome/free-solid-svg-icons';

library.add(faFileSignature, faCoins, faPiggyBank, faChartLine, faArrowRight, faQuestionCircle, faSync, faUser, faCashRegister, faGavel, faFileAlt, faListOl, faClipboardList, faCalendarAlt, faNotesMedical, faTooth, faFlask, faLaughBeam, faToolbox, faTasks, faReply, faFolderOpen, faFileMedicalAlt, faChild, faRandom, faSignOutAlt, faExclamationTriangle, faLaptopMedical, faStarHalfAlt, faClinicMedical, faPrint, faDiagnoses, faDrum, faDrumSteelpan, faCalendarCheck, faMoneyBill, faIdCard, faPaw, faLockOpen,
    faPencilAlt, faEye, faLock, faTeeth, faEdit, faCopy, faFileInvoice, faCheckCircle, faTimesCircle, faMoneyCheckAlt, faPrescriptionBottleAlt, faStickyNote,faArrowCircleRight,faAssistiveListeningSystems,faHistory,faUndoAlt,faExchangeAlt,faCircle);
import {fas} from '@fortawesome/free-solid-svg-icons';

library.add(fas);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.config.productionTip = false;

const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
};

import Schedule from "vue-schedule";

Vue.use(Schedule);

Vue.use(VueHtmlToPaper, optionsPaper);
Vue.use(VueSession);
Vue.use(VueNotifications, options);

Vue.use(VueRouter);
Vue.use(VueMaterial);
Vue.use(VueSweetalert2);
Vue.use(Animate);

// Optionally install the BootstrapVue icon components plugin
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueSignaturePad);
Vue.use(Slide);
import VueChartJs from 'vue-chartjs';

Vue.use(VueChartJs);

Vue.config.productionTip = false;


Vue.prototype.$debug = false;


const URLBase = process.env.VUE_APP_API_BASE_URL;
const URLBaseFacturacion = process.env.VUE_APP_PORTAL_FACTURACION;

const intercomApiBase = process.env.VUE_APP_INTERCOM_API_BASE;
const intercomAppId = process.env.VUE_APP_INTERCOM_APP_ID;
const intercomSecretKey = process.env.VUE_APP_INTERCOM_SECRET_KEY;

Vue.prototype.$registrosPorPaginaTabla = 15;
Vue.prototype.$registrosPorPagina = 10;
Vue.prototype.$baseURLFacturacion = URLBaseFacturacion;
Vue.prototype.$http = Axios;

Vue.prototype.$baseURL = URLBase;
Vue.prototype.$api = URLBase + "/api/";
Vue.prototype.$clinicaIdDefecto = 1;

Vue.prototype.$intercomApiBase = intercomApiBase;
Vue.prototype.$intercomAppId = intercomAppId;
Vue.prototype.$intercomSecretKey = intercomSecretKey;

// Vue.prototype.$apiUrl = "http://apiv2.dentalia.com.mx.vsealpide/"; // ?CAPACITACION
Vue.prototype.$apiUrl = "https://sbapiv3.dentalia.com.mx/"; // ?CAPACITACION
Vue.prototype.$apiToken = ""; // ?CAPACITACION

import CalendarioDentalia from "./components/calendario/CalendarioDentalia";

Vue.component("cal-dentalia", CalendarioDentalia);
import SalaCalendario from "./components/calendario/SalaCalendario";

Vue.component("sala-calendario", SalaCalendario);

import validacion from './components/Validacion'

Vue.component('validacion', validacion);





import HojaBienvenida from "./components/HojaBienvenida";
Vue.component("HojaBienvenida", HojaBienvenida);



/* MODAL INACTIVIDAD */
import Vuex from 'vuex'

Vue.use(Vuex);

import IdleVue from "idle-vue";

const eventsHub = new Vue();
const store = new Vuex.Store({
    // ...
})
Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    store,
    idleTime: 3600000, //60 mins
    startAtIdle: false
});
/* FIN MODAL INACTIVIDAD */

import VueMask from 'v-mask'
import {VueMaskDirective} from 'v-mask'
import {VueMaskFilter} from 'v-mask'

Vue.use(VueMask);
Vue.directive('mask', VueMaskDirective);
Vue.filter('VMask', VueMaskFilter)

// AGENDA CLINICA
import CalendarioClinica from "./components/agendaClinica/CalendarioClinica";

Vue.component("cal-clinica", CalendarioClinica);
import HorarioSillonCalendario from "./components/agendaClinica/HorarioSillonCalendario";

Vue.component("horario-sillon-calendario", HorarioSillonCalendario);

// AGENDA DOCTORES
import CalendarioDoctores from "./components/agendaDoctores/CalendarioDoctores";

Vue.component("cal-doctores", CalendarioDoctores);
import HorarioSillonDoctores from "./components/agendaDoctores/HorarioSillonDoctores";

Vue.component("BandejaLinkSeguimientoPTIComponente", BandejaLinkSeguimientoPTIComponente);

Vue.component("LinkPacientePtiVisibleComponente", LinkPacientePtiVisibleComponente);
Vue.component("LinkPacientePtiVisibleComponenteV5", LinkPacientePtiVisibleComponenteV5);

Vue.component("SemaforoSLA", SemaforoSLA);

Vue.component("horario-sillon-doctores", HorarioSillonDoctores);
import AltaPaciente from "./views/ventas/pacientes/altaPaciente";

Vue.component('app-alta-paciente', AltaPaciente)

import tratamientos from "./views/ventas/plan/tratamientos";

Vue.component('app-tratamiento', tratamientos)

import caracteristicas from "./views/ventas/plan/caracteristicas";

Vue.component('app-caracteristicas', caracteristicas)

/* Componentes para las bandejas */
import BandejaFechaComponente from "./components/bandejas/BandejaFechaComponente.vue";

Vue.component('BandejaFechaComponente', BandejaFechaComponente)
import BandejaFechaTextoComponente from "./components/bandejas/BandejaFechaTextoComponente.vue";

import BandejaFechaCantidadDiasTranscurridoComponente
    from "@/components/bandejas/BandejaSeguimientoPTI/BandejaFechaCantidadDiasTranscurridoComponente";
Vue.component('BandejaFechaCantidadDiasTranscurridoComponente', BandejaFechaCantidadDiasTranscurridoComponente)

Vue.component('BandejaFechaTextoComponente', BandejaFechaTextoComponente)
import BandejaFechaTextoCobroPtiComponente from "./components/bandejas/BandejaFechaTextoCobroPtiComponente.vue";

Vue.component('BandejaFechaTextoCobroPtiComponente', BandejaFechaTextoCobroPtiComponente)
/* bandeja de hallazgo */
import BandejaDiagnosticadorComponente from "./components/bandejas/BandejaHallazgo/BandejaDiagnosticadorComponente.vue";

Vue.component('BandejaDiagnosticadorComponente', BandejaDiagnosticadorComponente)
import BandejaLinkPacientePTIPresuntivoComponente
    from "./components/bandejas/BandejaHallazgo/BandejaLinkPacientePTIPresuntivoComponente.vue";

Vue.component('BandejaLinkPacientePTIPresuntivoComponente', BandejaLinkPacientePTIPresuntivoComponente)
import BandejaCambiarEstatusEnEsperaComponente
    from "./components/bandejas/BandejaHallazgo/BandejaCambiarEstatusEnEsperaComponente.vue";

Vue.component('BandejaCambiarEstatusEnEsperaComponente', BandejaCambiarEstatusEnEsperaComponente)
import HistorialBandejasPorPacienteComponente from "./components/bandejas/HistorialBandejasPorPacienteComponente.vue";

Vue.component('HistorialBandejasPorPacienteComponente', HistorialBandejasPorPacienteComponente)


/*Alto riesgo en el perfil del paciente */
/*import PacientePtiAltoRiesgoComponente from "./components/AltoRiesgo/PacientePtiAltoRiesgoComponente.vue";
Vue.component('PacientePtiAltoRiesgoComponente', PacientePtiAltoRiesgoComponente);*/
import AsignacionesPtiAltoRiesgoPacienteComponente
    from "./components/AltoRiesgo/AsignacionesPtiAltoRiesgoPacienteComponente.vue";
Vue.component('AsignacionesPtiAltoRiesgoPacienteComponente', AsignacionesPtiAltoRiesgoPacienteComponente);

import BandejaLinkPacienteCentroValidacionComponente
    from "@/components/bandejas/BandejaSeguimientoPTI/BandejaLinkPacienteCentroValidacionComponente";
Vue.component('BandejaLinkPacienteCentroValidacionComponente', BandejaLinkPacienteCentroValidacionComponente)




import BandejaCambiarEstatusIncompletosComponente
    from "./components/bandejas/BandejaHallazgoRechazados/BandejaCambiarEstatusIncompletosComponente.vue";

Vue.component('BandejaCambiarEstatusIncompletosComponente', BandejaCambiarEstatusIncompletosComponente)

Vue.component('BandejaEliminarSolicitudComponente', BandejaEliminarSolicitudComponente)

/*  Bandeja de hallazgos del embajador pendientes/rechazados  */
import NombrePacienteComponente from "./components/bandejas/NombrePacienteComponente.vue";

Vue.component('NombrePacienteComponente', NombrePacienteComponente)
import BandejaEmbajadorPendienteRegresarBandejaComponente
    from "./components/bandejas/BandejaEmbajadorPendienteRegresarBandejaComponente.vue";

Vue.component('BandejaEmbajadorPendienteRegresarBandejaComponente', BandejaEmbajadorPendienteRegresarBandejaComponente)


/* bandeja de hallazgo rechazados */
import BandejaMotivoRechazoComponente
    from "./components/bandejas/BandejaHallazgoRechazados/BandejaMotivoRechazoComponente.vue";

Vue.component('BandejaMotivoRechazoComponente', BandejaMotivoRechazoComponente)

/* bandeja de replica */
import BandejaLinkPacienteReplicaComponente
    from "./components/bandejas/BandejaReplica/BandejaLinkPacienteReplicaComponente.vue";

Vue.component('BandejaLinkPacienteReplicaComponente', BandejaLinkPacienteReplicaComponente)
import PacientePresencialComponente from "./components/bandejas/BandejaReplica/PacientePresencialComponente.vue";

Vue.component('PacientePresencialComponente', PacientePresencialComponente)
/* bandeja Embajador  hallazgo */
import BandejaEmbajadorComponente from "./components/bandejas/BandejaEmbajadorHallazgo/BandejaEmbajadorComponente.vue";

Vue.component('BandejaEmbajadorComponente', BandejaEmbajadorComponente)

import SelectEmbajadorComponente
    from "@/components/bandejas/BandejaEmbajadorHallazgo/SelectEmbajadorComponente.vue";
Vue.component('SelectEmbajadorComponente', SelectEmbajadorComponente)

import BandejaLinkPacientePresentacionPTIComponente
    from "./components/bandejas/BandejaEmbajadorHallazgo/BandejaLinkPacientePresentacionPTIComponente.vue";


Vue.component('BandejaLinkPacientePresentacionPTIComponente', BandejaLinkPacientePresentacionPTIComponente)
import BandejaLinkPacienteEmReplicaComponente
    from "./components/bandejas/BandejaEmbajadorReplica/BandejaLinkPacienteReplicaComponente.vue";

Vue.component('BandejaLinkPacienteEmReplicaComponente', BandejaLinkPacienteEmReplicaComponente)
import BandejaObservacionesDiagnostico
    from "./components/bandejas/BandejaEmbajadorHallazgo/BandejaObservacionesDiagnostico.vue";

Vue.component('BotonFinSolicitud', BotonFinSolicitud)

Vue.component('BandejaObservacionesDiagnostico', BandejaObservacionesDiagnostico)
import BandejaLinkPresentarReplicaComponente
    from "./components/bandejas/BandejaEmbajadorReplica/BandejaLinkPresentarReplicaComponente.vue";

Vue.component('BandejaLinkPresentarReplicaComponente', BandejaLinkPresentarReplicaComponente)


import BandejaRechazarPTIComponente
    from "./components/bandejas/BandejaEmbajadorHallazgo/BandejaRechazarPTIComponente.vue";

Vue.component('BandejaRechazarPTIComponente', BandejaRechazarPTIComponente)


/* Bandeja pti alto riesgo calidad dental */
import BandejaAsignacionesComponente
    from "./components/bandejas/BandejaCalidadDental/BandejaAsignacionesComponente.vue";

Vue.component('BandejaAsignacionesComponente', BandejaAsignacionesComponente)
import BandejaBotonAsignarComponente
    from "./components/bandejas/BandejaCalidadDental/BandejaBotonAsignarComponente.vue";

Vue.component('BandejaBotonAsignarComponente', BandejaBotonAsignarComponente)
import BandejaEspecialidadComponente
    from "./components/bandejas/BandejaCalidadDental/BandejaEspecialidadComponente.vue";

Vue.component('BandejaEspecialidadComponente', BandejaEspecialidadComponente)
import BandejaPorcentajeComponente from "./components/bandejas/BandejaCalidadDental/BandejaPorcentajeComponente.vue";

Vue.component('BandejaPorcentajeComponente', BandejaPorcentajeComponente)





import BandejaClasificacionComponente
    from "./components/bandejas/BandejaCalidadDental/BandejaClasificacionComponente.vue";

Vue.component('BandejaClasificacionComponente', BandejaClasificacionComponente)


//import BandejaBotonSeguimientoComponente from "./components/bandejas/BandejaCalidadDentalCoordinador/BandejaBotonSeguimientoComponente.vue";
//Vue.component('BandejaBotonSeguimientoComponente', BandejaBotonSeguimientoComponente)

import LinkPacientePerfilComponente from "./components/bandejas/LinkPacientePerfilComponente.vue";

Vue.component('LinkPacientePerfilComponente', LinkPacientePerfilComponente)

/* Bandeja especialistas */
import CheckReplicaComponente from "./components/bandejas/BandejaEspecialidad/CheckReplicaComponente.vue";

Vue.component('CheckReplicaComponente', CheckReplicaComponente)
import LinkPacientePerfilBandejaEspecialidadComponente
    from "./components/bandejas/BandejaEspecialidad/LinkPacientePerfilBandejaEspecialidadComponente.vue";

Vue.component('LinkPacientePerfilBandejaEspecialidadComponente', LinkPacientePerfilBandejaEspecialidadComponente)
import FinalizarSolicitudComponente from "./components/bandejas/BandejaEspecialidad/FinalizarSolicitudComponente.vue";

Vue.component('FinalizarSolicitudComponente', FinalizarSolicitudComponente)


/* Bandeja doctor hallazgo */
import BandejaDoctorLinkPacientePTIPresuntivoComponente
    from "./components/bandejas/BandejaDoctorHallazgo/BandejaDoctorLinkPacientePTIPresuntivoComponente.vue";

Vue.component('BandejaDoctorLinkPacientePTIPresuntivoComponente', BandejaDoctorLinkPacientePTIPresuntivoComponente)

/* Bandeja Replica coordinador especialidad */

import BandejaLinkPacienteReplicaCEComponente
    from "./components/bandejas/BandejaReplicaCoordinadorEs/BandejaLinkPacienteReplicaCEComponente.vue";

Vue.component('BandejaLinkPacienteReplicaCEComponente', BandejaLinkPacienteReplicaCEComponente)

import BandejaRegresarEstatusPendienteComponente
    from "./components/bandejas/BandejaRegresarEstatusPendienteComponente.vue";

Vue.component('BandejaRegresarEstatusPendienteComponente', BandejaRegresarEstatusPendienteComponente)

import ListaEspecialistasReplica from "./components/bandejas/BandejaClinica/ListaEspecialistasReplica.vue";

Vue.component('ListaEspecialistasReplica', ListaEspecialistasReplica)


/* Reportes Componentes */
import ReporteComponente from "./components/reportes/ReporteComponente.vue";

Vue.component('ReporteComponente', ReporteComponente)


import TablaComponente from "./components/reportes/TablaComponente.vue";

Vue.component('TablaComponente', TablaComponente)
/* Filtros de los reportes */
import ClinicasActivas from "./components/reportes/Filtros/ClinicasActivas.vue";

Vue.component('ClinicasActivas', ClinicasActivas)
import FechaInicio from "./components/reportes/Filtros/FechaInicio.vue";

Vue.component('FechaInicio', FechaInicio)
import FechaFinal from "./components/reportes/Filtros/FechaFinal.vue";

Vue.component('FechaFinal', FechaFinal)
import Especialidades from "./components/reportes/Filtros/Especialidades.vue";

Vue.component('Especialidades', Especialidades)
import Estados from "./components/reportes/Filtros/Estados.vue";

Vue.component('Estados', Estados)
import Planes from "./components/reportes/Filtros/Planes.vue";

Vue.component('Planes', Planes)
import HoraInicio from "./components/reportes/Filtros/HoraInicio.vue";

Vue.component('HoraInicio', HoraInicio)
import HoraFinal from "./components/reportes/Filtros/HoraFinal.vue";

Vue.component('HoraFinal', HoraFinal)
import ClinicasActivasPorEstado from "./components/reportes/Filtros/ClinicasActivasPorEstado.vue";

Vue.component('ClinicasActivasPorEstado', ClinicasActivasPorEstado)
import CifrasControl from "./components/reportes/Filtros/CifrasControl.vue";

Vue.component('CifrasControl', CifrasControl)


/* ortodoncia */
import OrtodonciaOpcionesComponente from "./components/ortodoncia/OrtodonciaOpcionesComponente.vue";

Vue.component('OrtodonciaOpcionesComponente', OrtodonciaOpcionesComponente)


import BandejaLinkPacienteCobroComponente
    from "./components/bandejas/BandejaCobro/BandejaLinkPacienteCobroComponente.vue";

Vue.component('BandejaLinkPacienteCobroComponente', BandejaLinkPacienteCobroComponente)


import HistorialHojasBienvenida from "./components/HistorialHojasBienvenida.vue";
Vue.component('HistorialHojasBienvenida', HistorialHojasBienvenida)

import BandejaInvisalingComponenteCapturar from "@/components/invisiling/BandejaInvisalingComponenteCapturar";
Vue.component("BandejaInvisalingComponenteCapturar", BandejaInvisalingComponenteCapturar);

import BandejaInvisalingComponenteEntregar from "@/components/invisiling/BandejaInvisalingComponenteEntregar";
Vue.component("BandejaInvisalingComponenteEntregar", BandejaInvisalingComponenteEntregar);


//Instalacion de Slider
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/antd.css';
Vue.component("VueSlider", VueSlider);

const formatoFechaFuncion = function (value) {
    if (value !== undefined && value !== null && value !== 'undefiend') {
        return moment(value).format("DD/MMMM/YYYY");
    }
}
Vue.prototype.$formatoFecha = formatoFechaFuncion;
Vue.filter("formatoFecha", formatoFechaFuncion);


const validarVersionNSDFunction = function ( usuario ) {


    if (localStorage.getItem("count") === undefined || localStorage.getItem("count") === null){
        localStorage.count = 1;
    }

    if (localStorage.getItem("tiempoVersion") === undefined || localStorage.getItem("tiempoVersion") === null){
        localStorage.tiempoVersion = new Date().getTime();
    }

    const url = this.$baseURL + "/version/obtenerVersion";
    //const url = this.$api + "dashboard/obtenerVersion";
    this.$http.get(url).then((response) => {
        localStorage.versionNSD = response.data.data;

        let countVersion = localStorage.getItem("count");


        const versionNSD = localStorage.getItem("versionNSD");
        if (versionNSD.localeCompare(process.env.VUE_APP_ENV_VERSION) !== 0 && localStorage.getItem("count") < 3){

            this.$swal.fire({
                /*icon: "warning",*/
                title: "<h6 style='font-size: 12px' ><b>Notamos que la versión que estás usando no es la última</b></h6>",
                /* html: '<div style="font-size: 12px"> Estamos actualizando la versión </div> <br>' +
                     '<div style="font-size: 12px; font-weight: 600;">Favor de esperar</div>',*/
                timer: 5000,
                showConfirmButton: false,
                showCancelButton: false,
                /* confirmButtonText: "Obtener la última versión",*/
                timerProgressBar: true,
                preConfirm: () => {
                    /**
                     .split('?')[0]: Esto elimina cualquier parámetro de la URL, en caso de que existan.

                     + '?' + new Date().getTime(): Agrega un parámetro de tiempo único a la URL,
                                                    lo que garantiza que la página se recargará sin usar la caché
                                                    (el parámetro con el valor de tiempo actual hace que la URL sea única en cada recarga de pantalla).

                     **/
                    window.location.href = window.location.href.split('?')[0] + '?' + new Date().getTime();

                    localStorage.count =  Number(countVersion) + 1
                },
            }).then(() => {
              //  setTimeout(() => location.reload(), 1000);
                window.location.href = window.location.href.split('?')[0] + '?' + new Date().getTime();
                localStorage.count =  Number(countVersion) + 1
            });
        }else if (versionNSD.localeCompare(process.env.VUE_APP_ENV_VERSION) !== 0){
            this.$swal.fire({
                icon: "error",
                /*title: "<h6 style='font-size: 12px' ><b>No pudimos actualizar la versión.</b></h6>",*/
                html: '<div style="font-size: 12px"> Te pedimos que borres el caché de tu navegador, vuelvas a entrar e intentes de nuevo </div> <br>',
                timer: 5000,
                confirmButtonText: "De acuerdo",
                closeOnClickOutside: false,
                allowOutsideClick: false,
                timerProgressBar: true,
            }).then(() => {
                localStorage.tiempoVersion = new Date().getTime();
                localStorage.count = 0;
                this.$guadarBitacoraCache(usuario);
            })
        }else{
            localStorage.tiempoVersion = new Date().getTime();
            localStorage.count = 0;
        }
    }).catch((error) => {
        this.$swal.fire({
            icon: "error",
            confirmButtonText: "De acuerdo",
            text: "No se pudo verificar la versión del NSD",
        });
        localStorage.count = 0;
        console.log(error.message);
    })
}
Vue.prototype.$validarVersionNSD = validarVersionNSDFunction;
Vue.filter("validarVersionNSD", validarVersionNSDFunction);


const guardarBitacoraCacheFunction = function ( usuario ) {
    var UAParser = require('ua-parser-js');
    // Create a new parser instance
    var parser = new UAParser();
    // Get the browser name and version
    var result = parser.getResult();
    console.log("Que navegador estamos usando NAME !!! >>>>>>>>>>>>>>>>>>>>>>>>", result.browser.name,"/", result.browser.version );
    const params= {
        navegador: result.browser.name+"/"+result.browser.version,
        versionActual: process.env.VUE_APP_ENV_VERSION,
        usuario: usuario,
    }
    this.$http.post(this.$baseURL + "/version/guardarBitacora", params).then((response) => {
        if (response.data.data){
            this.$router.push({
                name: "login"
            });
        }
    }).catch((error) => {
        console.error(error);
        window.location.href = window.location.href.split('?')[0] + '?' + new Date().getTime();
    });
}

Vue.prototype.$guadarBitacoraCache = guardarBitacoraCacheFunction;
Vue.filter("guadarBitacoraCache", guardarBitacoraCacheFunction);


const formatoFechaFuncion1 = function (value) {
    if (value !== undefined && value !== null && value !== 'undefiend') {
        return moment(value, "YYYY/MM/DD").format("DD/MMMM/YYYY");
    }
}
Vue.prototype.$formatoFecha1 = formatoFechaFuncion1;
Vue.filter("formatoFecha1", formatoFechaFuncion1);



const formatoFechaCortaFuncion = function (value) {
    if (value !== undefined && value !== null && value !== 'undefiend') {
        moment.updateLocale('es', {
            monthsShort: 'Ene_Feb_Mar_Abr_May_Jun_Jul_Ago_Sep_Oct_Nov_Dic'.split('_')

        });
        return moment(value).format("DD/MMM/YYYY");
    }
}


const formatoFechaCortaDMA = function (value) {
    if (value !== undefined && value !== null && value !== 'undefiend') {
        moment.updateLocale('es', {
            monthsShort: 'Ene_Feb_Mar_Abr_May_Jun_Jul_Ago_Sep_Oct_Nov_Dic'.split('_')

        });
        return moment(value).format("DD-MM-YYYY");
    }
}


Vue.prototype.$formatoFechaCorta = formatoFechaCortaFuncion;
Vue.filter("formatoFechaCorta", formatoFechaCortaFuncion);

Vue.prototype.$formatoFechaCortaDMA = formatoFechaCortaDMA;
Vue.filter("formatoFechaCortaDMA", formatoFechaCortaDMA);


const emailState = function (value) {
    if (value === '') return null
    const regex = /^[^\s@]+@[^\s@]+\.(com|org)$/i
    return regex.test(value)
}
Vue.prototype.$emailState = emailState;
Vue.filter("emailState", emailState);

const formatoHoraFuncion = function (value) {
    if (value !== undefined && value !== null && value !== 'undefiend') {
        return moment(value).format("hh:mm A");
    }
}
Vue.prototype.$formatoHora = formatoHoraFuncion;
Vue.filter("formatoHora", formatoHoraFuncion);

const formatoHoraIntegerFuncion = function (value) {
    if (value !== undefined && value !== null && value !== 'undefiend' && value > 0) {

        if(value.toString().length < 4){
            value = PadLeft(value, 4);
        }

        const num = value.toString().split('')
        return num[0] + num[1] + ':' + num[2] + num[3];
    }else if(value === '0'){
            return '00:00'
    } else {
        return "Sin dato";
    }
}
Vue.prototype.$formatoHoraIntegerFuncion = formatoHoraIntegerFuncion;
Vue.filter("formatoHoraDeEntero", formatoHoraIntegerFuncion);

const PadLeft = function (value, length) {
    return (value.toString().length < length) ? PadLeft("0" + value, length) : value;
}

const formatoHoraDeHoraFuncion = function (value) {
    if (value !== undefined && value !== null && value !== 'undefiend') {
        return moment('01/01/2000 ' + value).format("hh:mm A");
    }
}
Vue.prototype.$formatoHoraDeHora = formatoHoraDeHoraFuncion;
Vue.filter("formatoHoraDeHora", formatoHoraDeHoraFuncion);

const formatoInicialesFuncion = function (value) {

    const arregloDeSubCadenas = value.split(" ");

    let iniciales = "";
    let inicialesNA = "";
    for (let x = 0; x < arregloDeSubCadenas.length; x++) {
        iniciales += arregloDeSubCadenas[x].substring(0, 1);
    }
    inicialesNA += iniciales.charAt(0) + iniciales.charAt(arregloDeSubCadenas.length-2);

    
    return inicialesNA.toUpperCase();
}


Vue.prototype.$formatoIniciales = formatoInicialesFuncion;
Vue.filter("formatoIniciales", formatoInicialesFuncion);

const formatoSoloIniciales = function (value) {

    const arregloDeSubCadenas = value.split(" ");

    let iniciales = "";
    let inicialesNA = "";
    for (let x = 0; x < arregloDeSubCadenas.length; x++) {
        iniciales += arregloDeSubCadenas[x].substring(0, 1);
    }
    inicialesNA += iniciales.charAt(0) + iniciales.charAt(arregloDeSubCadenas.length);


    return inicialesNA.toUpperCase();
}


Vue.prototype.formatoSoloIniciales = formatoSoloIniciales;
Vue.filter("formatoSoloIniciales", formatoSoloIniciales);



const formatoFechahoraFuncion = function (value) {
    if (value !== undefined && value !== null && value !== 'undefiend' && value !== '') {
        return moment(value).format("DD/MMM/YYYY hh:mm A");
    } else {
        return 'Sin fecha';
    }
};

Vue.filter("formatoFechaHora", formatoFechahoraFuncion);
Vue.prototype.$formatoFechaHora = formatoFechahoraFuncion;


const inicialesfuncion = function (value) {
    if (value === undefined || value === null) {
        return "";
    }

    const separador = " ";
    const arregloDeSubCadenas = value.split(separador);

    let titulo = "";
    for (let x = 0; x < arregloDeSubCadenas.length; x++) {
        titulo += arregloDeSubCadenas[x].substring(0, 1);
    }

    return titulo.toUpperCase();
}

const horasDiferenciaUtc = function () {
    const fecha = this.$moment(new Date()).format("Z")

    let arrayHora = fecha.split(':');

    return parseInt(arrayHora[0]);
}
Vue.filter("iniciales", inicialesfuncion);
Vue.prototype.$horas = horasDiferenciaUtc;
Vue.prototype.$iniciales = inicialesfuncion;

Vue.filter("formatoFechaHoraTexto", function (value) {
    if (value !== undefined && value !== null && value !== 'undefiend') {
        var fechaDate = new Date(value);
        var options = {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            hour12: "true",
        };
        var nuevaFecha = fechaDate.toLocaleDateString("es-ES", options);

        const acentos = {
            á: "a",
            é: "e",
            í: "i",
            ó: "o",
            ú: "u",
            Á: "A",
            É: "E",
            Í: "I",
            Ó: "O",
            Ú: "U",
        };
        nuevaFecha = nuevaFecha
            .split("")
            .map((letra) => acentos[letra] || letra)
            .join("")
            .toString();

        return (
            nuevaFecha &&
            nuevaFecha.replace(/\b\w/g, function (l) {
                return l.toUpperCase();
            })
        );
    }
});

Vue.filter("formatoFechaTexto", function (value) {
    if (value !== undefined && value !== null && value !== 'undefiend') {
        var fechaDate = new Date(value);
        var options = {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
        };
        var nuevaFecha = fechaDate.toLocaleString("es-ES", options);

        const acentos = {
            á: "a",
            é: "e",
            í: "i",
            ó: "o",
            ú: "u",
            Á: "A",
            É: "E",
            Í: "I",
            Ó: "O",
            Ú: "U",
        };
        nuevaFecha = nuevaFecha
            .split("")
            .map((letra) => acentos[letra] || letra)
            .join("")
            .toString();

        return (
            nuevaFecha &&
            nuevaFecha.replace(/\b\w/g, function (l) {
                return l.toUpperCase();
            })
        );
    }
});

const funcionMoneda = function (value) {
    if (value === undefined || value === null) {
        return "";
    } else {
        let moneda = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
        }).format(value);
        return moneda.slice(0, -3);
    }
}
Vue.prototype.$formatoMoneda = funcionMoneda;
Vue.filter("moneda", funcionMoneda);

const funcionMonedaDecimal = function (value) {
    if (value === undefined || value === null) {
        return "";
    } else {
        let moneda = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
        }).format(value);
        return moneda;
    }
}
Vue.prototype.$formatoMonedaDecimal = funcionMonedaDecimal;
Vue.filter("monedaDecimal", funcionMonedaDecimal);


const funcionMonedaSinDecimal = function (value) {
    if (value === undefined || value === null) {
        return "";
    } else {
        let moneda = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
        }).format(value);
        return moneda.slice(0, -3);
    }
}
Vue.prototype.$formatoMoneda = funcionMonedaSinDecimal;
Vue.filter("monedaSinDecimal", funcionMonedaSinDecimal);



const onlyNumber = (evt) => {

    const keyEvent = (keyevt) => {
        if (isNumeric(keyevt.key) || keyevt.key === '.' && keyevt.target.value.split('.').length <= 2) {
            return true;
        } else {
            keyevt.target.value = '';
            keyevt.preventDefault();
            return false;
        }
    }
    const pasteEvento = (pasteEvent) => {
        const content = evt.clipboardData.getData('text');
        if (isNumeric(content)) {
            return true;
        } else {
            pasteEvent.target.value = '';
            pasteEvent.preventDefault();
            return false;
        }
    }

    const isNumeric = (str) => {
        if (typeof str != "string")
            return false // we only process strings!
        return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
            !isNaN(parseFloat(str))
    }

    if (evt)
    switch (evt.type) {
        case 'keypress': {
            return keyEvent(evt);
        }
        case 'keyup': {
            return keyEvent(evt);
        }
        case 'paste': {
            return pasteEvento(evt)
        }
    }

}
Vue.prototype.$onlyNumber = onlyNumber;
const onlyNumberInt = (evt) => {

    const keyEvent = (keyevt) => {
        if (isNumeric(keyevt.key)) {
            return true;
        } else {
            keyevt.target.value = '';
            keyevt.preventDefault();
            return false;
        }
    }
    const pasteEvento = (pasteEvent) => {
        const content = evt.clipboardData.getData('text');
        if (isNumeric(content)) {
            return true;
        } else {
            pasteEvent.target.value = '';
            pasteEvent.preventDefault();
            return false;
        }
    }

    const isNumeric = (str) => {
        if (typeof str != "string")
            return false // we only process strings!
        return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
            !isNaN(parseFloat(str))
    }

    if (evt)
    switch (evt.type) {
        case 'keypress': {
            return keyEvent(evt);
        }
        case 'keyup': {
            return keyEvent(evt);
        }
        case 'paste': {
            return pasteEvento(evt)
        }
    }

}
Vue.prototype.$onlyNumberInt = onlyNumberInt;




const funcionMonedaEntero = function (value) {
    if (value === undefined || value === null) {
        return "";
    } else {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 0
        }).format(value);
    }
}
Vue.prototype.$formatoMonedaEntero = funcionMonedaEntero;
Vue.filter("monedaEntero", funcionMonedaEntero);

const funcionMonedaDecimales = function (value) {
    if (value === undefined || value === null) {
        return "";
    } else {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2
        }).format(value);
    }
}
Vue.prototype.$funcionMonedaDecimales = funcionMonedaDecimales;
Vue.filter("monedaDecimales", funcionMonedaDecimales);

const funcionNumeroEntero = function (value) {
    if (value === undefined || value === null) {
        return "";
    } else {
        return new Intl.NumberFormat("en-US", {
            maximumFractionDigits: 0
        }).format(value);
    }
}
Vue.prototype.$funcionNumeroEntero = funcionNumeroEntero;
Vue.filter("numeroEntero", funcionNumeroEntero);

const funcionNumeroDosDecimales = function (value) {
    if (value === undefined || value === null) {
        return "";
    } else {
        return new Intl.NumberFormat("en-US", {
            maximumFractionDigits: 2
        }).format(value);
    }
}
Vue.prototype.$funcionNumeroDosDecimales = funcionNumeroDosDecimales;
Vue.filter("numeroDosDecimales", funcionNumeroDosDecimales);


const funcionNumeroRedondeo = function (value) {
    if (value === undefined || value === null) {
        return "";
    } else {
        return Math.round(value);
    }
}
const funcionNumeroRedondeoArriba = function (value) {
    if (value === undefined || value === null) {
        return "";
    } else {
        return Math.ceil(value);
    }
}
Vue.prototype.$funcionNumeroRedondeo = funcionNumeroRedondeo;
Vue.filter("numeroRedondeo", funcionNumeroRedondeo);

Vue.prototype.funcionNumeroRedondeoArriba = funcionNumeroRedondeoArriba;
Vue.filter("numeroRedondeoArriba", funcionNumeroRedondeoArriba);


const formatoSINOFuncion = function (value) {
    if (value === undefined || value === null || !value) {
        return 'NO';
    } else {
        return 'SI';
    }
}
Vue.prototype.$formatoSINOFuncion = formatoSINOFuncion;
Vue.filter("sino", formatoSINOFuncion);


const funcionEsLetra = function (e) {
    let char = String.fromCharCode(e.keyCode); // Get the character
    if (/^[A-Za-zÁÉÍÓÚáéíóúñÑ\s]+$/.test(char)) return true;
    // Match with regex
    else e.preventDefault(); // If not match, don't add to input text
}

Vue.prototype.$funcionEsLetra = funcionEsLetra;


const formatoHorasMinEstandar = function (value) {

    if (value === undefined || isNaN(value) || value === null || value === '' || value === 0) {
        return null;
    }

    const ToTime = (mins) => {
        const horas = Math.floor(mins / 60);
        const horasTot = Math.abs(horas);

        const minutos = Math.floor((mins - (horasTot * 60)));

        let tiempoCad = horasTot > 0 ? horasTot + "hr " : "";
        tiempoCad += minutos > 0 ? minutos + "min" : "" ;

        return tiempoCad;
    }

    return ToTime(value);
}
Vue.prototype.$formatoHorasMinEstandar = formatoHorasMinEstandar;
Vue.filter("formatoHorasMinEstandar", formatoHorasMinEstandar);


const formatoFechaHace = function (fechaInicio) {
    if (fechaInicio !== undefined && fechaInicio !== null) {
        let Leyenda = "Hace ";

        const fechaHoy = this.$moment();
        let fechaFin = fechaInicio;

        let duration = this.$moment.duration(fechaHoy.diff(fechaFin));
        const diffAnios = Math.abs(Math.floor(duration.asYears()));

        if (diffAnios == 1) {
            Leyenda += "1 año ";
        } else if (diffAnios > 0) {
            Leyenda += diffAnios+" años ";
        }

        fechaFin = fechaFin.add(diffAnios, 'years');
        duration = this.$moment.duration(fechaHoy.diff(fechaFin));
        const diffMeses = Math.abs(Math.floor(duration.asMonths()));

        if (diffMeses > 0) {
            if (diffMeses == 1) {
                Leyenda += "1 mes ";
            } else if (diffMeses > 1) {
                Leyenda += diffMeses + " meses "
            }
        }

        fechaFin = fechaFin.add(diffMeses, 'months');
        duration = this.$moment.duration(fechaHoy.diff(fechaFin));
        const diffDias = Math.abs(Math.floor(duration.asDays()));

        if (diffDias > 0) {
            if (diffDias == 1) {
                Leyenda += " 1 día"
            } else {
                Leyenda += diffDias + " días"
            }
        }else{
            Leyenda += "0 días"
        }

        return Leyenda;
    }
    return "";
}
Vue.prototype.$formatoFechaHace = formatoFechaHace;
Vue.filter("formatoFechaHace", formatoFechaHace);

const bytesToKBOrMB = function (bytes) {
    if (bytes !== undefined && bytes !== null && bytes !== '') {
        if (bytes < 1024) {
            return bytes + " B";
        } else if (bytes < 1048576) {
            return (bytes / 1024).toFixed(1) + " KB";
        } else {
            return (bytes / 1048576).toFixed(1) + " MB";
        }
    } else {
        return '';
    }
}
Vue.prototype.$bytesToKBOrMB = bytesToKBOrMB;
Vue.filter("bytesToKBOrMB", bytesToKBOrMB);


const validarSegmentacionPlan = function (porcentajeDescuentoActualPlan, operador, valorRegla) {

    if (operador==null || valorRegla ==null) { //si es solo validacion por plan, que no valide las reglas, de lo contrario que valide los porcentajes de planes
        //console.info("-------****validarSegmentacionPlan 01** OPERADOR O REGLA NULA", porcentajeDescuentoActualPlan, operador, valorRegla);
        return true;
    }

    let resultado = false;

    if (operador == "=") {
        resultado = porcentajeDescuentoActualPlan == valorRegla;
    } else if (operador == ">") {
        resultado = porcentajeDescuentoActualPlan > valorRegla;
    } else if (operador == "<") {
        resultado = porcentajeDescuentoActualPlan < valorRegla;
    } else if (operador == ">=") {
        resultado = porcentajeDescuentoActualPlan >= valorRegla;
    } else if (operador == "<=") {
        resultado = porcentajeDescuentoActualPlan <= valorRegla;
    }

    //console.info("-------****validarSegmentacionPlan 02*** ", porcentajeDescuentoActualPlan, operador, valorRegla, resultado);
    return resultado;
}
Vue.prototype.$validarSegmentacionPlan = validarSegmentacionPlan;

/**
 * Interceptor sesión
 */

import LocalStorageService from "./services/LocalStorageService";

const localStorageService = LocalStorageService.getService();
Vue.prototype.$localStorageService = LocalStorageService.getService();


Axios.interceptors.request.use(
    request => {

        if (!request.url.includes("sugarondemand")) {
            const token = localStorageService.getAccessToken();
            if (token) {
                request.headers["Authorization"] = token;
            }
        }

        if (!request.url.includes("/login") &&
            !request.url.includes("/firma/guardar") &&
            !request.url.includes("/version/obtenerVersion") &&
            !request.url.includes("/saldo/registrar") &&
            !request.url.includes("/guardar/imagen") &&
            !request.url.includes("/saldo/actualizar") &&
            !request.url.includes("/empresas/imagen") &&
            !request.url.includes("/planConvenio/guardar/imagen") &&
            !request.url.includes("/archivos/guardar") &&
            !request.url.includes("/firma/guardar") &&
            !request.url.includes("/firma/guardarFirmaTestigoUno") &&
            !request.url.includes("/firma/guardarFirmaTestigoDos") &&
            !request.url.includes("/rutaExpediente/subirArchivo") &&
            !request.url.includes("/sharepoint/subirArchivo") &&
            !request.url.includes("/postal/crear") &&
            !request.url.includes("/herramientaExpedienteElectronico/subirHerramienta") &&
            !request.url.includes("/pacienteV5/guardar/ortopantomografo") &&
            request.data !== undefined && request.data !== null) {

            const datoOriginal = request.data;

            if (process.env.VUE_APP_SECURE_API !== undefined &&
                (process.env.VUE_APP_SECURE_API === true || process.env.VUE_APP_SECURE_API === 'true')) {

                var keyForCryptoJS = CryptoJS.enc.Base64.parse(btoa(process.env.VUE_APP_SECURE_KEY_API));

                request.headers["Content-Type"] = "application/json";
                request.data = CryptoJS.AES.encrypt(JSON.stringify(request.data), keyForCryptoJS, {
                    mode: CryptoJS.mode.ECB /* Override the defaults */
                    /*padding: CryptoJS.pad.Pkcs7 *//* PKCS#5 is a subset of PKCS#7, and */
                }).toString();
            }

            if (process.env.VUE_APP_DEBUG_API !== undefined &&
                (process.env.VUE_APP_DEBUG_API === true || process.env.VUE_APP_DEBUG_API === 'true')) {
                console.info("######### request", datoOriginal, request.data);
            }
        }
        request.headers["Access-Control-Allow-Origin"] = '*';
        return request;
    },
    (error) => {
        return Promise.reject(error);
    }
);

Axios.interceptors.response.use(
    response => {

        if (!response.config.url.includes("socket.io") && !response.config.url.includes("/login")
            && response.data !== undefined && response.data !== null) {

            try {

               if (process.env.VUE_APP_SECURE_API !== undefined &&
                   (process.env.VUE_APP_SECURE_API === true || process.env.VUE_APP_SECURE_API === 'true')) {
                   response.data = JSON.parse(desencriptar(response.data).toString(CryptoJS.enc.Utf8));
                }

                if (process.env.VUE_APP_DEBUG_API !== undefined &&
                    (process.env.VUE_APP_DEBUG_API === true || process.env.VUE_APP_DEBUG_API === 'true')) {
                    console.info("######### response", response.config.url, response.data);
                }
            } catch (e) {
                console.error(e);
            }
        }
        return response;
    },
    (error) => {
        try {
            if (process.env.VUE_APP_SECURE_API !== undefined &&
                (process.env.VUE_APP_SECURE_API === true || process.env.VUE_APP_SECURE_API === 'true')) {
                error.response.data = JSON.parse(desencriptar(error.response.data).toString(CryptoJS.enc.Utf8));
            }
            return Promise.reject(error);
        } catch(e) {
            console.error(e);
            return Promise.reject(e);
        }
    }
);

const desencriptar = function(data) {
    const keyForCryptoJS = CryptoJS.enc.Base64.parse(btoa(process.env.VUE_APP_SECURE_KEY_API));
    const decodeBase64 = CryptoJS.enc.Base64.parse(data);

    const decryptedData = CryptoJS.AES.decrypt({ciphertext:decodeBase64}, keyForCryptoJS,
        {
            mode: CryptoJS.mode.ECB /* Override the defaults */
            /*padding: CryptoJS.pad.Pkcs7 *//* PKCS#5 is a subset of PKCS#7, and */
        }
    );

    return decryptedData;
}
Vue.prototype.$desencriptar = desencriptar;

const copiar = function copy(text) {
    var input = document.createElement('textarea');
    input.innerHTML = text;
    document.body.appendChild(input);
    input.select();
    var result = document.execCommand('copy');
    document.body.removeChild(input);
    return result;
}
Vue.prototype.$copiar = copiar;

import FuncionesAyuda from './services/FuncionesAyuda.js';
import BandejaLinkSeguimientoPTIComponente
    from "@/components/bandejas/BandejaEmbajadorHallazgo/BandejaLinkSeguimientoPTIComponente";
import LinkPacientePtiVisibleComponente   from "@/components/bandejas/LinkPacientePtiVisibleComponente";
import SemaforoSLA from "@/components/bandejas/BandejaSeguimientoPTI/SemaforoSLA";
import BotonFinSolicitud from "@/components/bandejas/BotonFinSolicitud";

Vue.prototype.$global = FuncionesAyuda;

import { datadogRum } from '@datadog/browser-rum';
import BandejaEliminarSolicitudComponente
    from "@/components/bandejas/BandejaSeguimientoPTI/BandejaEliminarSolicitudComponente";
import LinkPacientePtiVisibleComponenteV5 from "@/version5/bandejas/LinkPacientePtiVisibleComponenteV5.vue";


datadogRum.init({
    applicationId: '4c8c2780-4816-4070-b373-5578b1724e8f',
    clientToken: 'pub5e89704786008fe7c663ff88cc33ee7b',
    site: 'us5.datadoghq.com',
    service:'front-java-nsd-qa',
    env: process.env.VUE_APP_ENV_DATADOG,
    version: process.env.VUE_APP_ENV_VERSION,
    sessionSampleRate:100,
    premiumSampleRate: 100,
    trackUserInteractions: true,
    defaultPrivacyLevel:'mask-user-input',
    allowedTracingUrls: [/https:\/\/.*\.dentalia\.com\.mx/]
});
datadogRum.startSessionReplayRecording();

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
